import { apiUrls } from "../plugins/apiUrls";
import axios from "axios";
import { userStore } from '../store/modules';

class User {
    constructor (
        full_name = null,
        categorie = null,
        username = null,
        password = null,
        repit_password = null
    )
    {
        this.full_name = full_name;
        this.categorie = categorie;
        this.username = username;
        this.password = password;
        this.repit_password = repit_password;
    }
    static async getUsers(id, disabled = 2) {
        const response = await axios.get(
            `${apiUrls.USER}/list?id=${id}&disabled=${disabled}`,
            { headers: userStore.state.header }
        );
        return response.data;
    }
    static async addUser(parameters) {
        const response = await axios.post(
            `${apiUrls.USER}/add`,
            parameters,
            { headers: userStore.state.header }
        );
        return response.data;
    }
    static async editUser(parameters) {
        const response = await axios.put(
            `${apiUrls.USER}/edit`,
            parameters,
            { headers: userStore.state.header }
        );
        return response.data;
    }
    static async changeState(parameters) {
        const response = await axios.patch(
            `${apiUrls.USER}/change-state`,
            parameters,
            { headers: userStore.state.header }
        );
        return response.data;
    }
    static async changeCredentials(parameters) {
        const response = await axios.put(
            `${apiUrls.USER}/change-credentials`,
            parameters,
            { headers: userStore.state.header }
        );
        return response.data;
    }
    static async login(parameters) {

        const response = await axios.post(
            `${apiUrls.USER}/login`,
            parameters
        );
        return response.data;
    }
    static async logout() {
        const response = await axios.post(
            `${apiUrls.USER}/logout`,
            {},
            { headers: userStore.state.header }
        );
        return response.data;
    }
}
export default User;